/*
 * Panorama Studios
 */
$(document).ready(function () {
	// Responsive menu
	$('header').each(function () {
		var element = $(this),
			body = $(document.body),
			responsiveNav = $('.responsive-nav');

		var toggler = $('<div class="toggler toggler--closed"><span>Menu</span></div>').click(function () {
			body.toggleClass('open');
			responsiveNav.toggleClass('collapsed');
			toggler.toggleClass('toggler--closed');
		}).appendTo(element);

		responsiveNav.find('nav > ul > li').each(function () {
			var element = $(this);
			var link = element.children('a').first();
			link.click(function (e) {
				responsiveNav.toggleClass('collapsed');
				toggler.toggleClass('toggler--closed');
				e.preventDefault();
			});
		});
	});

	// Header affix
	var headerHeight = $('header .navigation-container').outerHeight();

	$('header .navigation-container').each(function () {
		var element = $(this);
		var headroom = element.headroom();

		if (element.hasClass('headroom')) {
			$(document.body).addClass('headroom--enabled');
		}
	});

	// Gumshoe
	$('.navigation ul').each(function () {
		gumshoe.init({
			offset: headerHeight
		});
	});

	// Packages content
	$('.package').each(function () {
		var element = $(this),
			content = element.find('.columns'),
			parent = element.parents('.packages')[0];

		$(window).on("load resize", function (e) {
			// Set top position based on element
			var pos = element.position();

			content.css("left", -pos.left);
			content.width(element.parent().outerWidth() - 80);
		});

		// Set click
		$(window).click(function () {
			element.removeClass('active');
		});

		element.click(function (event) {
			// Remove the active class from all elements with active class
			if (element.hasClass('active')) {
				element.removeClass('active');
			}
			else {
				$(".package").removeClass("active");
				element.addClass("active");

				$('html, body').animate({
					scrollTop: content.offset().top - headerHeight
				}, 500);
			}
			event.stopPropagation();
		});
	});


	// Slideshows
	$('.slideshow--hero').each(function () {
		var element = $(this);
		if (element.children('figure').length > 1) {
			element.lightSlider({
				item: 1,
				slideMargin: 0,
				addClass: element.attr('class'),
				mode: 'fade',
				speed: 1000,
				auto: true,
				loop: true,
				pause: 5000,
				controls: false,
				pager: true,
				onBeforeSlide: function (el, i) {
					// TODO: Move CSS to stylesheet and use classes
					el.children('.lslide').eq(i).find('figcaption').css({
						'margin-top': '10px',
						'opacity': '0',
						'transition': 'none'
					});
				},
				onAfterSlide: function (el, i) {
					el.children('.lslide').eq(i).find('figcaption').css({
						'margin-top': '0',
						'opacity': '1',
						'transition': 'transform 1s ease 0s, opacity 1s ease 0s, margin 1s ease 0s, background 1s ease 0s'
					});
				}
			});
		}
	});

	// Slideshows
	$('.slideshow--testimonials').each(function () {
		var element = $(this);
		if (element.children('figure').length > 1) {
			element.lightSlider({
				item: 1,
				slideMargin: 0,
				addClass: element.attr('class'),
				mode: 'fade',
				speed: 1000,
				auto: true,
				loop: true,
				pause: 7000,
				controls: false,
				pager: true,
				onBeforeSlide: function (el, i) {
					// TODO: Move CSS to stylesheet and use classes
					el.children('.lslide').eq(i).find('figcaption h2').css({
						'margin-top': '10px',
						'opacity': '0',
						'transition': 'none'
					});
					el.children('.lslide').eq(i).find('figcaption .button').css({
						'opacity': '0',
						'transition': 'none'
					});
				},
				onAfterSlide: function (el, i) {
					el.children('.lslide').eq(i).find('figcaption h2').css({
						'margin-top': '0',
						'opacity': '1',
						'transition': 'transform 1s ease 0s, opacity 1s ease 0s, margin 1s ease 0s, background 1s ease 0s'
					});
					el.children('.lslide').eq(i).find('figcaption .button').css({
						'opacity': '1',
						'transition': 'transform 1s ease 1s, opacity 1s ease 1s, background 1s ease 1s'
					});
				}
			});
		}
	});

	// Lightbox
	$('#container').lightGallery({
		selector: '[rel=lightbox]',
		download: false
	});

	// Route form
	$('.form--route').each(function () {
		var element = $(this);
		var button = element.find('button');
		var destinationAddress = element.find('input[type=text]');
		var destination = button.attr('data-address');

		button.click(function (e) {
			var route = {
				saddr: destinationAddress.val(),
				daddr: destination
			};

			window.open('https://maps.google.com/?' + $.param(route), '_blank');

			e.preventDefault();
		});
	});

	// Smooth scroll
	$('a[href*="#"]').click(function () {
		var target = $(this.hash);
		if (!target.length) {
			target: $('[name=' + this.hash.slice(1) + ']');
		}
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top - headerHeight
			}, 500);

			return false;
		}
	});

	// Change target for external sites
	var getDomainName = function (hostName) {
		return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
	};
	$('a:not([target])').filter(function () {
		var link = $(this);

		if (link.filter('[rel~="external"]').length) return true; // Link rel attribute contains 'external'

		var href = link.attr('href');
		if (new RegExp('\.pdf$', 'i').test(href)) return true; // Link to PDF file

		if (new RegExp('^https?://', 'i').test(href)) {
			var linkHostName = getDomainName(href.substring(href.indexOf('/') + 2, href.indexOf('/', 8)));
			if (!new RegExp('(^|\.)' + getDomainName(document.location.hostname) + '$', 'i').test(linkHostName)) {
				// Link is to different domain name
				return true;
			}
		}

		return false;
	}).attr('target', '_blank');
});